import { render, staticRenderFns } from "./FundDataCell.vue?vue&type=template&id=8ad23e20&scoped=true&"
import script from "./FundDataCell.vue?vue&type=script&lang=js&"
export * from "./FundDataCell.vue?vue&type=script&lang=js&"
import style0 from "./FundDataCell.vue?vue&type=style&index=0&id=8ad23e20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad23e20",
  null
  
)

export default component.exports